import { useReduxState } from 'hooks';
import { ApiDownloadButton } from 'components/common';

const AccessListDownload = () => {
  const { messages, serverConfig } = useReduxState();

  return (
    <ApiDownloadButton
      category="success"
      filename={`${serverConfig.hostname}-access.xlsx`}
      icon="file-excel"
      text={messages.commonDownload}
      url="/admin/events-access-export"
    />
  );
};

export default AccessListDownload;
